import {Component, OnDestroy, OnInit} from '@angular/core';
import {ConfiguratorService} from '../../../services/configurator.service';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-hydrosila-header',
  templateUrl: './hydrosila-header.component.html',
  styleUrls: ['./hydrosila-header.component.scss']
})
export class HydrosilaHeaderComponent implements OnInit, OnDestroy {
  languages: Array<any> = [];
  lang = '';
  subscribtions: Subscription = new Subscription();

  constructor(private configuratorService: ConfiguratorService,
              private translate: TranslateService) {

    this.languages = this.configuratorService.langList;
    console.log(this.languages)
    this.lang = translate.currentLang;
    this.subscribtions.add(translate.onLangChange.subscribe((data) => {
        this.lang = data.lang;
      })
    );

  }

  ngOnInit() {
  }

  changeLanguage(lang: string): void {
    localStorage.setItem('dafault_lang', lang);
    this.translate.use(lang);
  }

  doSearch() {
    document.forms[0].submit();
  }

  ngOnDestroy() {
    this.subscribtions.unsubscribe();
  }
}
